package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

/**
 * Refreshes a ticket's thread from Gmail (single thread fetch + upsert).
 * Used in background when the user opens a ticket so the view can show up-to-date messages.
 * Does not run extract; caller should reload respond state after if needed.
 */
class RefreshTicketThreadUseCase(private val repo: TicketsRepository) {
    suspend operator fun invoke(ticketId: String) {
        repo.refreshTicketThread(ticketId)
    }
}
